import ServicesHero from "@/pages/services/ServicesHero";
import ServiceOverview from "@/pages/services/ServiceOverview";
import ServiceFTL from "@/pages/services/ServiceFTL";
import ServiceDedicated from "@/pages/services/ServiceDedicated";
import ServiceExpedite from "@/pages/services/ServiceExpedite";
import ServiceSpecialized from "@/pages/services/ServiceSpecialized";
import Service3PL from "@/pages/services/Service3PL";
import NotSure from "@/pages/services/NotSure";
import FinalCta from "@/pages/home/FinalCta";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function ServicesPage() {
  usePageMeta({
    title: "Transportation Services | 30 NORTH",
    description:
      "Explore 30 NORTH transportation and logistics services, including FTL, partial loads, dedicated transportation, expedited delivery, specialized delivery, and 3PL solutions.",
    path: "/services",
  });

  return (
    <div data-testid="services-page">
      <ServicesHero />
      <ServiceOverview />
      <ServiceFTL />
      <ServiceDedicated />
      <ServiceExpedite />
      <ServiceSpecialized />
      <Service3PL />
      <NotSure />
      <FinalCta headline="LET'S FIND THE RIGHT WAY TO MOVE IT." />
    </div>
  );
}
